import { useDispatch } from "react-redux"
// import { UsersType, deleteUsers } from "../redux/actions/usersActions"
import { PurchaseType, deletePurchaseAction } from "../redux/actions/purchaseActions"
import { AppDispatch } from "../redux/store"
import { ToastTypes, useToast } from "./toast/ToastProvider"


interface Props {
    editData?: PurchaseType
    onClose: () => void
    // onDelete: () => void
}

// type HandleDelete = (value: TransactionType) => void

const DeleteConfirmPurchase = ({ editData, onClose }: Props) => {

    const toast = useToast()
    const dispatch = useDispatch<AppDispatch>()

    const handleDeleteYes = () => {
        if (editData !== undefined && editData.id !== undefined) {

            dispatch(deletePurchaseAction(editData.id)).then(text => {
                toast(text, ToastTypes.SUCCESS)
                setTimeout(() => {
                    onClose()
                }, 2000)
                // onClose()
            }).catch(text => {
                toast(text, ToastTypes.ERROR)
            })
        }
    }

    return <>
        <div className="container">
            <div className="row m-0">
                <div className="col-lg-12 col-md-8 col-sm-8 my-1">
                    <label className="fs-4 text-black">Do You Really Want To Delete this record ?</label>
                </div>
                <div className="hstack gap-1 d-flex justify-content-end ">
                    <button className="btn btn-sm fw-bold btn-danger" onClick={handleDeleteYes}>Delete</button>
                    <button className="btn btn-sm fw-bold btn-primary" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    </>
}
export default DeleteConfirmPurchase